import {DrupalNode} from "next-drupal";
import {Dictionary, DrupalDocumentMedia, DrupalSearchApiResponseMeta} from "@/types/hygiena-types";
import {getKvpPair} from "@/lib/get-kvp-pair";
import SectionHeading from "../../organisms/section-heading";
import {WidgetCertificateSearch} from "@/components/organisms/widget--certificate-search";
import {WidgetDocumentSearch} from "@/components/organisms/widget--document-search";
import {FormattedText} from "@/components/formatted-text";
import {useContext} from "react";
import {DictionaryContext} from "@/context/dictionary-context";

interface DocumentLibraryPageProps {
  node: DrupalNode,
  documents?: DrupalDocumentMedia[],
  documentSearchMeta?: DrupalSearchApiResponseMeta,
  initialLanguage?: string,
};

export function DocumentLibraryPage({node, documents, documentSearchMeta, initialLanguage}: DocumentLibraryPageProps) {
  const t = useContext<Dictionary>(DictionaryContext);
  const description = getKvpPair(node, "description", "long")?.value;

  return (
    <>
      <div className="container pb-4 px-6 md:px-0 mx-auto mt-12">
        <SectionHeading title={node?.title}>
          {description && <FormattedText processed={description}/>}
        </SectionHeading>
      </div>
      <div className="container px-4 md:px-0 pb-6 mx-auto mb-8">
        <WidgetDocumentSearch documents={documents} meta={documentSearchMeta} initialLanguage={initialLanguage} hideFacets={["field_document_region", "field_document_industry", "field_document_technology", "name"]}/>
      </div>
      <div className="container pb-4 px-6 md:px-0 mx-auto flex gap-12">
        <div className="w-full md:w-1/2 flex flex-col">
          <SectionHeading title={`${t?.documents?.coa_search}`}/>
          <WidgetCertificateSearch />
        </div>
      </div>
    </>
  );
}